import React from "react"
import Link from "./Link"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

const ReadMoreBasicCard = ({ data }) => {
  const { slug, name, author, updatedAt } = data
  return (
    <div className="text-gray-900 space-y-4">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className="w-[2.75rem] h-[2.75rem]">
            <GatsbyImage
              alt={author.name}
              image={author.image.gatsbyImageData}
              className="rounded-full"
              imgStyle={{ borderRadius: "50%" }}
            />
          </div>
          <p className="text-gray-900 text-base font-bold">{author.name}</p>
        </div>
      </div>
      <div className="divide-y divide-gray-900">
        <Link to={`/blog/${slug}`}>
          <p className="text-2xl sm:text-3xl tracking-wide !leading-normal font-bold line-clamp-2">
            {name}
          </p>
          <p className="text-base sm:text-lg line-clamp-3 pt-4">
            {data?.excerpt.excerpt}
          </p>
        </Link>
      </div>
      <p className="text-gray-500 text-end">{updatedAt}</p>
    </div>
  )
}

export default ReadMoreBasicCard

ReadMoreBasicCard.propTypes = {
  data: PropTypes.object,
}
